function SessionExpireHandler(product = '', event = '', data = {}) {
    const { metaData = {}, searchQuery = {} } = data,
        { searchId = '', searchCriteria = {} } = searchQuery,
        { cityName = '' } = searchCriteria,
        { userId } = metaData;

    let finalData = {
        Identity: userId, product: product, searchId, location: cityName
    }

    switch (event) {
        case 'Popup':
            break;
        case 'SearchAgain':
            break;
    }
    return finalData;
}

module.exports = { SessionExpireHandler }